import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { id: "container" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Ready to create an app?"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode("Start with Ionic "),
      /*#__PURE__*/_createElementVNode("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: "https://ionicframework.com/docs/components"
      }, "UI Components")
    ])
  ])
], -1)

import { 
    IonPage, 
    IonContent, 
} from '@ionic/vue';

import TopNavigation from '@/partials/TopNavigation.vue';
import BottomNavigation from '@/partials/BottomNavigation.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(TopNavigation, { name: "Home" }),
      _createVNode(_unref(IonContent), {
        fullscreen: true,
        class: "ion-padding"
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(BottomNavigation)
    ]),
    _: 1
  }))
}
}

})